<template>
  <div class="overlay">
    <div class="modal-wrapper p-4 bg-white rounded shadow">
      <portlet :actionsBlock="true">
        <template #portletBody>
          <div class="container">
            <div class="row">
              <div class="col-12">
                <h4 class="mb-4">Send Message to {{ employeeName }}</h4>
                <div class="form-group mb-4">
                  <input 
                    type="text"
                    class="form-control"
                    v-model="subject"
                    placeholder="Message subject…" 
                  />
                </div>
                <textarea
                  class="form-control mb-4"
                  v-model="message"
                  placeholder="Type your message..."
                  rows="8"
                ></textarea>
                <div class="d-flex justify-content-between">
                  <button class="btn btn-secondary" style="color: white" @click="$emit('close')">
                    Cancel
                  </button>
                  <button
                    class="btn btn-primary"
                    :disabled="!canSend"
                    @click="onSend"
                  >
                    Send Message
                  </button>
                </div>
              </div>
            </div>
          </div>
        </template>
      </portlet>

      <button class="close-btn" @click="$emit('close')">&times;</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageModal',
  props: {
    employeeName: {
      type: String,
      required: true
    },
    employmentId: {
      type: [String, Number],
      required: true
    },
    allowAnswer: {
        type: Boolean,
        required: false,
        default: false
    }
  },
  data() {
    return {
      message: '',
      subject: ''
    }
  },
  computed: {
    canSend() {
      return this.subject.trim() !== '' && this.message.trim() !== '';
    }
  },
  methods: {
    onSend() {
      this.$emit('sendMessage', {
        employmentId: this.employmentId,
        employeeName: this.employeeName,
        subject: this.subject,
        message: this.message,
        allowAnswer: this.allowAnswer
      });
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-wrapper {
  position: relative;
  width: 600px;
  max-width: 95%;
  background: #fff;
}

.btn {
  border-radius: 10px;
}

.modal-wrapper .btn-primary {
  background-color: #FF924E;
  border: none;
}

.modal-wrapper .btn-secondary {
  background-color: #146F70;
  border: none;
}

.modal-wrapper .btn-primary:hover {
  background-color: #E58346;
}

.modal-wrapper .btn-secondary:hover {
  background-color: #126465;
}

.close-btn {
  position: absolute;
  top: 1.5rem;
  right: 2rem;
  background: transparent;
  border: none;
  font-size: 2.5rem;
  color: #333;
  cursor: pointer;
}

::v-deep .m-portlet__head {
  display: none;
}
</style> 